import { useEffect, useState } from "react";
import { Upload, MessageSquare, LogIn, ShieldAlert, Settings, CheckCircle2, Clock, User, Flag, Ban, Award, ShoppingBag, CalendarCheck } from "lucide-react";
import { KidAvatar } from "../Brand";
import { parentApi } from "../../lib/api";
import { timeAgo } from "../../lib/constants";

const KIND = {
  upload: { icon: Upload, bg: "#FFD23F" }, comment: { icon: MessageSquare, bg: "#FF8FC7" }, login: { icon: LogIn, bg: "#3DCCC7" },
  blocked: { icon: ShieldAlert, bg: "#FF6B4A" }, settings: { icon: Settings, bg: "#E0D7FF" }, review: { icon: CheckCircle2, bg: "#B8F2C9" },
  screen_time: { icon: Clock, bg: "#9BD0FF" }, profile: { icon: User, bg: "#FFF7EC" }, report: { icon: Flag, bg: "#FF8FC7" }, block: { icon: Ban, bg: "#E0D7FF" }, badge: { icon: Award, bg: "#FFD23F" },
  shop: { icon: ShoppingBag, bg: "#FFB86B" }, daily: { icon: CalendarCheck, bg: "#B8F2C9" },
};

export const ActivityLog = ({ kids }) => {
  const [kidId, setKidId] = useState("");
  const [items, setItems] = useState(null);
  const byId = Object.fromEntries(kids.map((k) => [k.id, k]));

  useEffect(() => { parentApi.get("/parent/activity", { params: { kid_id: kidId || undefined } }).then((r) => setItems(r.data)); }, [kidId]);

  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-bold">Activity</h1>
      <div className="flex gap-2 flex-wrap">
        <button data-testid="activity-filter-all" onClick={() => setKidId("")} className={`zn-chip ${!kidId ? "bg-[#1B1A2E] text-white" : "bg-white"}`}>Everyone</button>
        {kids.map((k) => <button key={k.id} data-testid={`activity-filter-${k.id}`} onClick={() => setKidId(k.id)} className={`zn-chip ${kidId === k.id ? "bg-[#FFD23F]" : "bg-white"}`}>{k.name}</button>)}
      </div>
      <div className="zn-card bg-white p-2 sm:p-4" data-testid="activity-list">
        {items?.length === 0 && <p className="p-6 text-center">No activity yet.</p>}
        {items?.map((a) => {
          const { icon: Icon, bg } = KIND[a.kind] || KIND.profile;
          const k = byId[a.kid_id];
          return (
            <div key={a.id} data-testid={`activity-item-${a.id}`} className="flex items-center gap-4 p-3 rounded-2xl hover:bg-[#FFF7EC] transition-colors">
              <span className="w-10 h-10 shrink-0 grid place-items-center rounded-xl border-[3px] border-[#1B1A2E]" style={{ background: bg }}><Icon size={18} /></span>
              <p className="flex-1 min-w-0 break-words">{a.message}</p>
              {k && <KidAvatar avatar={k.avatar} color={k.color} frame={k.frame} size={28} className="!border-2 hidden sm:inline-grid" />}
              <span className="text-xs text-[#1B1A2E]/60 whitespace-nowrap">{timeAgo(a.created_at)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
